import type { Billing, Plan } from "../../shared/types.ts";

export type Paid = Exclude<Plan, "free">;

export const paidPlan = (v: string | null): Paid | null => (v === "autopilot" || v === "max" ? v : null);

const KEY = "headcount:plan";

/** Remembers the plan picked on the landing page, in localStorage so it survives an email confirmation in a new tab. */
export function pickPlan(plan: Plan): void {
  try {
    if (plan === "free") localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, plan);
  } catch {}
}

/** The plan picked before sign-in, if any. */
export function pickedPlan(): Paid | null {
  try {
    return paidPlan(localStorage.getItem(KEY));
  } catch {
    return null;
  }
}

export function forgetPlan(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {}
}

const wait = (ms: number) => new Promise<void>((r) => setTimeout(r, ms));

/**
 * Billing once it shows `want`, polled for about twelve seconds because Stripe's webhook can land after the redirect back,
 * then whatever it shows. With no `want` it reads once.
 */
export async function settle(read: () => Promise<Billing>, want: Plan | null, pause = wait): Promise<Billing> {
  for (let i = 0; ; i++) {
    const b = await read();
    if (!want || b.plan === want || i >= 8) return b;
    await pause(1500);
  }
}
